// extracted by mini-css-extract-plugin
module.exports = {"xxs":"1","xs":"1","s":"1","m":"1","l":"1","xl":"1","xxl":"1"};